module.exports = __webpack_public_path__ + "static/media/pic9.42369847.jpg";